// extracted by mini-css-extract-plugin
module.exports = {"player":"Player_player__DCE4f","flip":"Player_flip__3Y1N2","handoffMode":"Player_handoffMode__1KG8s bg-snow--d"};